import { Box, Grid, GridItem, useToast } from "@chakra-ui/react";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchStatusOfTimeline } from "../../api/timelineService";
import { getAllDocumentsResponse } from "../../constants";
import { setDocumentsFromApiCall } from "../../Redux/documentsSlice";
import {
  findCurrentTimelineStepOrSubstep,
  getFirstDigitAfterDecimal,
} from "../../utils/UTILITY_METHODS";
import ChatBox from "../ChatBox/ChatBox";
import DocumentsShimmer from "../Shimmer/DocumentsShimmer";
import DocumentDetailsTab from "./DocumentDetailsTab";

const DocumentDetails = () => {
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // excutes the below method, before the browser starts painting
  useLayoutEffect(() => {
    if (!localStorage.getItem("access_token")) {
      setLoading(false);
      navigate("/");
      return;
    }
  }, [navigate]);

  useEffect(() => {
    const getAllDocuments = async () => {
      try {
        // const data = await fetchAllDocuments();
        // console.log(data);
        const response = getAllDocumentsResponse;
        dispatch(setDocumentsFromApiCall(response.data));
        const timelineResponse = await fetchStatusOfTimeline();
        const { steps } = timelineResponse.data.status;
        const incompleteSubstep = findCurrentTimelineStepOrSubstep(steps);
        if (incompleteSubstep === -1) {
          setCurrentTabIndex(-1);
        } else if (
          incompleteSubstep.name === "financial_statements" &&
          !incompleteSubstep.completed
        ) {
          setCurrentTabIndex(0); // meaning user has not completed financial_statements so redirecting it to identification statements
        } else {
          setCurrentTabIndex(
            getFirstDigitAfterDecimal(incompleteSubstep.substep_id)
          );
        }
        setLoading(false);
      } catch (error) {
        toast({
          title: error.message,
          position: "top",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        setLoading(false);
      }
    };

    getAllDocuments();
  }, [toast, dispatch]);

  const handleUserTabClicked = (clickedTabIndex) => {
    setCurrentTabIndex(clickedTabIndex);
  };

  return (
    <>
      {loading ? (
        <DocumentsShimmer />
      ) : (
        <Grid
          templateColumns={{ base: "repeat(1, 1fr)", md: "65% 35%" }}
          gap={2}
          minH="90vh"
          alignItems="stretch"
          mt={5}
        >
          <GridItem w="100%" mx={"auto"} px={5} py={3} ml={5}>
            <Box
              boxShadow={
                "rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px;"
              }
              borderRadius="2xl"
              minHeight={"60%"}
              backgroundColor={"white"}
            >
              <DocumentDetailsTab
                currentTabIndex={currentTabIndex}
                handleUserTabClicked={handleUserTabClicked}
              />
            </Box>
          </GridItem>
          <GridItem w="100%" h="100%" p={4} mr={10}>
            <ChatBox />
          </GridItem>
        </Grid>
      )}
    </>
  );
};

export default DocumentDetails;
